import { Fetch, FetchAttachment } from '../Models/shared/general';

//#region ======== ACTIONS ========
const actions = {
    //======== TASKS MANAGEMENT ======
    task_task_create        : "task_task_create",
    task_list_get           : "task_list_get",
    task_lists_get          : "task_10lists_get",
    task_relatedlist_get    : "task_relatedlist_get",
    task_search_get         : "task_search_get",
    task_task_update        : "task_task_update",
    task_date_get           : "task_date_get",
    task_taskid_get         : "task_taskid_get",
    task_list_getallstatus  : "task_list_getallstatus",
    reminder_task_upsert    : "reminder_task_upsert",
    reminder_others_upsert  : "reminder_others_upsert",
    get_reminder_status     : "get_reminder_status",
    remove_reminder_status  : "remove_reminder_status",
    remove_reminder2_status : "remove_reminder2_status",
    remove_reminder3_status : "remove_reminder3_status",
    task_remove_taguser     : "task_remove_taguser",
    task_self_deadline      : "task_self_deadline",
    task_update_hide        : "task_update_hide",
    task_checklist_byid     : "task_checklist_byid",
    task_checklist_insertnew: "task_checklist_insertnew",
    task_checklist_update   : "task_checklist_update",
    task_checklist_remove   : "task_checklist_remove",
    //====== CHAT =====
    task_chat_create        : "task_chat_create",
    task_task_unread        : "task_task_unread",
    task_update_subtaskmsg  : "task_update_subtaskmsg",
    get_task_chat           : "get_task_chat",
    reminder_unread_update  : "reminder_unread_update",
    task_previous_deadline  : "task_previous_deadline"

};
//#endregion
  

//#region ========== API FUNCTIONS ===========

export async function task_checklist_insertnew(data){
    return Fetch({action: actions.task_checklist_insertnew, data:data})
}

export async function task_checklist_remove(data){
    return Fetch({action: actions.task_checklist_remove, data:data})
}
export async function task_checklist_update(data){
    return Fetch({action: actions.task_checklist_update, data:data})
}

export async function task_checklist_byid(data){
    return Fetch({action: actions.task_checklist_byid, data:data})
}

export async function task_task_create(data){
    return Fetch({ action: actions.task_task_create, data: data });
}

export async function task_list_get(data){
    return Fetch({ action: actions.task_list_get, data: data });
}

export async function task_taskid_get(data){
    return Fetch({ action: actions.task_taskid_get, data: data });
}

export async function task_lists_get(data){
    return Fetch({ action: actions.task_lists_get, data: data });
}
export async function task_list_getallstatus(data){
    return Fetch({ action: actions.task_list_getallstatus, data: data });
}

export async function task_relatedlist_get(data){
    return Fetch({ action: actions.task_relatedlist_get, data: data });
}

export async function task_search_get(data){
    return Fetch({ action: actions.task_search_get, data: data });
}

export async function task_remove_taguser(data){
    return Fetch({ action: actions.task_remove_taguser, data: data });
}

export async function task_task_update(data){
    return Fetch({ action: actions.task_task_update, data: data });
}

export async function reminder_task_upsert(data){
    return Fetch({ action: actions.reminder_task_upsert, data: data });
}

export async function reminder_unread_update(data){
    return Fetch({ action: actions.reminder_unread_update, data: data });
}

export async function reminder_others_upsert(data){
    return Fetch({ action: actions.reminder_others_upsert, data: data });
}
export async function remove_reminder_status(data){
    return Fetch({ action: actions.remove_reminder_status, data: data });
}
export async function remove_reminder2_status(data){
    return Fetch({ action: actions.remove_reminder2_status, data: data });
}
export async function remove_reminder3_status(data){
    return Fetch({ action: actions.remove_reminder3_status, data: data });
}
export async function get_reminder_status(data){
    return Fetch({ action: actions.get_reminder_status, data: data });
}

export async function task_task_unread(data){
    return Fetch({ action: actions.task_task_unread, data: data });
}
export async function task_update_subtaskmsg(data){
    return Fetch({ action: actions.task_update_subtaskmsg, data: data });
}
export async function task_date_get(data){
    return Fetch({ action: actions.task_date_get, data: data });
}

export async function task_update_hide(data){
    return Fetch({ action: actions.task_update_hide, data:data})
}

//====== CHAT =====
export async function task_chat_create(data){
    return Fetch({ action: actions.task_chat_create, data: data });
}

export async function get_task_chat(data){
    return Fetch({ action: actions.get_task_chat, data: data });
}

//========= ATTACHMENT ===========
export async function chat_attachment_create(data){
    return FetchAttachment({ data: data });
}

export async function task_self_deadline(data){
    return Fetch({action: actions.task_self_deadline, data:data})
}

export async function task_previous_deadline(data){
    return Fetch({action: actions.task_previous_deadline, data:data})
}
//#endregion


